import React, { useCallback } from 'react';
import { FollowCard } from '../follows/FollowCard';
import { FollowingIcon } from '../../svg/dashboard/FollowingIcon';
import {
    Espin_Role_Enum,
    PlayerFollowingFragment,
    UnfollowCollegeDocument,
    UnfollowCollegeMutation,
    UnfollowCollegeMutationVariables,
} from '../../../generated/spin-graphql';
import { gql } from '@urql/core';
import { useAuthenticatedMutation } from '../../../client/hooks';
import { useAppState } from '../../../client/providers/AppProvider';

type Props = {
    closeColleges: PlayerFollowingFragment[];
    farColleges: PlayerFollowingFragment[];
    selectedPlayer?: number;
    listOfFollows: string[];
};

gql`
    fragment PlayerFollowing on espin_follow {
        id
        ...FollowCard
    }
`;

export const PlayerFollowing: React.FC<Props> = ({ closeColleges, farColleges, selectedPlayer, listOfFollows }) => {
    const { user } = useAppState();
    const [_, unFollowCollege] = useAuthenticatedMutation<UnfollowCollegeMutation, UnfollowCollegeMutationVariables>(
        UnfollowCollegeDocument,
    );

    const handleFollowButtonClicked = useCallback(
        (collegeId: string) => {
            if (user.role === Espin_Role_Enum.EspinParentUser) {
                const playerId = user.parent_profile.child_profiles[0].user_id;
                return unFollowCollege(
                    { collegeId, playerUserId: playerId },
                    { additionalTypenames: ['espin_follow'] },
                );
            }
            unFollowCollege({ collegeId, playerUserId: user?.id }, { additionalTypenames: ['espin_follow'] });
        },
        [unFollowCollege, user?.id, user?.parent_profile?.child_profiles, user?.role],
    );

    return (
        <div className="follow-container">
            <FollowCard
                playerCollegesFollowing={listOfFollows}
                className="player-following-card"
                title="Colleges within 100 miles"
                unsubbedTitle="Unlock Following"
                unsubbedSubtitle="Upgrade to Premium to follow colleges!"
                fakeDataSubtitle="Upgrade to Premium to follow colleges!"
                followingList={closeColleges}
                totalFollowing={closeColleges.length}
                noContentIcon={<FollowingIcon />}
                noContentLabel={'You are not following any colleges yet'}
                selectedChild={selectedPlayer}
                handleFollowButtonClicked={(collegeId) => handleFollowButtonClicked(collegeId)}
            />
            <FollowCard
                playerCollegesFollowing={listOfFollows}
                className="player-following-card"
                title="Colleges further than 100 miles"
                unsubbedTitle="Unlock Following"
                unsubbedSubtitle="Upgrade to Premium to follow colleges!"
                fakeDataSubtitle="Upgrade to Premium to follow colleges!"
                followingList={farColleges}
                totalFollowing={farColleges.length}
                noContentIcon={<FollowingIcon />}
                noContentLabel={'You are not following any colleges yet'}
                selectedChild={selectedPlayer}
                handleFollowButtonClicked={(collegeId) => handleFollowButtonClicked(collegeId)}
            />
        </div>
    );
};
